var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hasManualVariables)?_c('div',{staticClass:"manual-variables-table"},[(_vm.loading)?_c('gl-loading-icon'):_c('variable-table',{attrs:{"variables":_vm.variables}})],1):_c('empty-state')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }